import React, { Fragment } from "react";

import { Title, StyledP2 } from "../styles";

export const thankYouElement = (
  <Fragment>
    <Title>Thank You</Title>
    <StyledP2>
      We will review your project and send out a preliminary quote shortly.
    </StyledP2>
    <StyledP2>
      If you have any questions, please give us a call at 508-535-5100.
    </StyledP2>
  </Fragment>
);
